import DatePicker from '@/trio-ui/DatePicker';
import DropDown from '@/trio-ui/Dropdown';
import InputText from '@/trio-ui/InputText';
import { EmployeeWorkStatus, Ethnicity, PersonGender } from '@/types/api';
import { makeDateWithCurrentTime } from '@/utils/dates';
import { ethnicityOptions, genderOptions } from '@/utils/staffMember';
import { Grid, InputWrapper } from './PersonalInfoBasicInfoForm.styles';

type Props = {
  firstName: string;
  lastName: string;
  birthdate?: string;
  gender: string;
  employeeWorkStatus: string;
  ethnicity: string;
  isMyPersonalInfo?: boolean;
  onChange: (name: string, value: any) => void;
};

const PersonalInfoBasicInfoForm = ({
  firstName,
  lastName,
  birthdate,
  gender,
  employeeWorkStatus,
  ethnicity,
  onChange,
  isMyPersonalInfo = false,
}: Props): JSX.Element => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>): void => {
    onChange(e.target.name, e.target.value);
  };

  return (
    <Grid>
      <InputWrapper>
        <InputText
          label="First Name"
          name="firstName"
          value={firstName}
          onChange={handleChange}
          readonly={isMyPersonalInfo}
        />
      </InputWrapper>
      <InputWrapper>
        <DatePicker
          name="birthdate"
          dateFormat="MM/dd/yyyy"
          label="Birth Date"
          value={birthdate ? makeDateWithCurrentTime(birthdate) : undefined}
          onChange={(date) => onChange('birthdate', date)}
          disabled={isMyPersonalInfo}
        />
      </InputWrapper>
      <InputWrapper>
        <InputText
          label="Last Name"
          name="lastName"
          value={lastName}
          onChange={handleChange}
          readonly={isMyPersonalInfo}
        />
      </InputWrapper>
      <InputWrapper>
        <DropDown
          label="Gender"
          options={genderOptions}
          name="gender"
          defaultValue={gender as PersonGender}
          onChangeDropDown={handleChange}
        />
      </InputWrapper>
      <InputWrapper>
        <DropDown
          label="Ethnicity"
          options={ethnicityOptions}
          name="ethnicity"
          defaultValue={ethnicity as Ethnicity}
          onChangeDropDown={handleChange}
        />
      </InputWrapper>
    </Grid>
  );
};

export default PersonalInfoBasicInfoForm;
